import { ScrollArea } from '../ui/scroll-area';
import { cn } from '../../lib/utils';
import { Folder, FileText, ChevronRight } from 'lucide-react';

export default function TaskBrowser({ 
  categories, 
  tasks, 
  selectedCategory, 
  selectedTask, 
  onSelectCategory, 
  onSelectTask,
  agentName 
}) {
  const filteredTasks = selectedCategory 
    ? tasks.filter(t => t.category_id === selectedCategory.id)
    : tasks;

  return (
    <div className="h-full bg-[#030712] flex flex-col" data-testid="task-browser">
      {/* Header */}
      <div className="p-3 border-b border-[#1E293B] bg-[#0F172A]">
        <div className="flex items-center gap-2 text-xs text-[#64748B]">
          <span>{agentName || 'Select Agent'}</span>
          {selectedCategory && (
            <>
              <ChevronRight className="w-3 h-3" />
              <span className="text-[#94A3B8]">{selectedCategory.name}</span>
            </>
          )}
        </div>
        <h2 className="text-sm font-medium text-[#F1F5F9] mt-1">Tasks & Prompts</h2>
      </div>

      <div className="flex-1 flex overflow-hidden">
        {/* Categories */}
        <div className="w-1/3 border-r border-[#1E293B]">
          <div className="p-2 text-[10px] uppercase tracking-wider text-[#64748B] font-medium">
            Categories
          </div>
          <ScrollArea className="h-[calc(100%-28px)]">
            <div className="p-1 space-y-0.5">
              {categories.length === 0 ? (
                <div className="p-3 text-center text-[#64748B] text-xs">
                  No categories
                </div>
              ) : (
                categories.map(category => (
                  <button
                    key={category.id}
                    onClick={() => onSelectCategory(category)}
                    className={cn(
                      "w-full px-2 py-2 rounded-sm text-left text-xs transition-all flex items-center gap-2",
                      selectedCategory?.id === category.id
                        ? "bg-[#0EA5E9]/10 text-[#F1F5F9] border-l-2 border-[#0EA5E9]"
                        : "text-[#94A3B8] hover:bg-[#1E293B]"
                    )}
                    data-testid={`category-${category.id}`}
                  >
                    <Folder className="w-3.5 h-3.5 flex-shrink-0" />
                    <span className="truncate">{category.name}</span>
                  </button>
                ))
              )}
            </div>
          </ScrollArea>
        </div>

        {/* Tasks */}
        <div className="flex-1">
          <div className="p-2 text-[10px] uppercase tracking-wider text-[#64748B] font-medium">
            Tasks ({filteredTasks.length})
          </div>
          <ScrollArea className="h-[calc(100%-28px)]">
            <div className="p-1 space-y-0.5">
              {filteredTasks.length === 0 ? (
                <div className="p-4 text-center text-[#64748B] text-xs">
                  No tasks in this category
                </div>
              ) : (
                filteredTasks.map(task => (
                  <button
                    key={task.id}
                    onClick={() => onSelectTask(task)}
                    className={cn(
                      "w-full px-2 py-2 rounded-sm text-left text-xs transition-all flex items-center gap-2",
                      selectedTask?.id === task.id
                        ? "bg-[#0EA5E9]/10 text-[#F1F5F9] border-l-2 border-[#0EA5E9]"
                        : "text-[#94A3B8] hover:bg-[#1E293B]"
                    )}
                    data-testid={`task-${task.id}`}
                  >
                    <FileText className="w-3.5 h-3.5 flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <div className="truncate">{task.name}</div>
                      {task.description && (
                        <div className="text-[10px] text-[#64748B] truncate mt-0.5">
                          {task.description}
                        </div>
                      )}
                    </div>
                  </button>
                ))
              )}
            </div>
          </ScrollArea>
        </div>
      </div>
    </div>
  );
}
